import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AddPage from './pages/AddPage';
import EditPage from './pages/EditPage';
import HomePage from './pages/HomePage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/edit/:jobId" element={<EditPage />} />
        <Route exact path="/add" element={<AddPage />} />
      </Routes>
    </Router>
  );
};

export default App;
